<!-- SIDEBAR HEADER -->
<div fxLayout="column" fxLayoutAlign="space-between start"
     class="header primary p-24 pb-4">
    <div class="logo" fxFlex fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon s-32" [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
            check_box
        </mat-icon>
        <span class="logo-text" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">To-Do</span>
    </div>

</div>
<!-- / SIDEBAR HEADER -->

<!-- SIDEBAR CONTENT -
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">

    

    <div class="nav material2">

        <div class="nav-item">
            <a class="nav-link" matRipple [routerLink]="'/apps/todo/all'"
               [routerLinkActive]="['active', 'accent']">
                <mat-icon class="nav-link-icon">view_headline</mat-icon>
                <span>All</span>
            </a>
        </div>

    </div>

</div>
<!-- / SIDEBAR CONTENT -->
